export default __webpack_public_path__ + "static/media/Impressum.0559866b.md";